import { z } from './utils/zod.js';
export const dashboardStatsScopeSchema = z.enum(['user', 'organization']);
export const dashboardStatsResponseSchema = z.object({
    awaitingSignature: z.number().int().nonnegative(),
    active: z.number().int().nonnegative(),
    completedThisMonth: z.number().int().nonnegative(),
    completedThisMonthSince: z.string().datetime(),
    scope: dashboardStatsScopeSchema,
});
const signingRefSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
});
const personRefSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
});
export const needsAttentionTypeSchema = z.enum([
    'deadline_approaching',
    'review_rejected',
    'stale_unsigned',
    'expired',
    'review_pending_too_long',
]);
export const needsAttentionItemSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('deadline_approaching'),
        occurredAt: z.string().datetime(),
        signing: signingRefSchema,
        expirationDate: z.string().datetime(),
    }),
    z.object({
        type: z.literal('review_rejected'),
        occurredAt: z.string().datetime(),
        signing: signingRefSchema,
        reviewer: personRefSchema.nullable(),
    }),
    z.object({
        type: z.literal('stale_unsigned'),
        occurredAt: z.string().datetime(),
        signing: signingRefSchema,
        sentAt: z.string().datetime(),
    }),
    z.object({
        type: z.literal('expired'),
        occurredAt: z.string().datetime(),
        signing: signingRefSchema,
    }),
    z.object({
        type: z.literal('review_pending_too_long'),
        occurredAt: z.string().datetime(),
        signing: signingRefSchema,
        reviewer: personRefSchema.nullable(),
    }),
]);
export const needsAttentionResponseSchema = z.object({
    data: z.array(needsAttentionItemSchema),
    scope: dashboardStatsScopeSchema,
});
export const recentActivityItemSchema = z.object({
    id: z.string().uuid(),
    action: z.string(),
    occurredAt: z.string().datetime(),
    signing: signingRefSchema,
    actorName: z.string().nullable(),
});
export const recentActivityResponseSchema = z.object({
    data: z.array(recentActivityItemSchema),
    scope: dashboardStatsScopeSchema,
});
